<div class="container" fxLayout fxLayoutAlign="center center" fxLayoutGap="25px" fxLayout.xs="column wrap"
    fxLayoutGap.xs="20px">
    <mat-card fxFlex="60" class="cardPadding">
        <mat-card-content>
            <h2 class="createLeadTitle">Real Estate</h2>
            <form [formGroup]="createRealForm" fxLayoutAlign="stretch" fxLayout="column">
                <mat-form-field class="full-width">
                    <mat-label>Name</mat-label>
                    <input type="text" required formControlName="name" matInput autocomplete="off">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Phone</mat-label>
                    <input formControlName="phone" type="tel" required matInput>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Referral Source</mat-label>
                    <input formControlName="referral_source" required matInput>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Area</mat-label>
                    <input formControlName="area" matInput>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Notes</mat-label>
                    <input formControlName="notes" matInput>
                </mat-form-field>

                <div *ngFor="let item of additionalNotes">
                    <mat-form-field *ngIf="item.notes !== null" class="half-width" appearance="outline">
                        <mat-label>Additonal Note</mat-label>
                        <textarea [value]="item.notes" matInput matTextareaAutosize></textarea>
                    </mat-form-field>&nbsp;&nbsp;
                    <span *ngIf="item.notes !== null" class="fieldLabel inputField-margin">{{item.updated_at | date}},
                        {{item.updated_at | date:'shortTime'}}</span>
                </div>

                <div formArrayName="notesArray"
                    *ngFor="let note of createRealForm.get('notesArray')['controls'] let i = index">
                    <mat-form-field class="full-width" [formGroupName]="i">
                        <mat-label>Add Additional Note</mat-label>
                        <input matInput formControlName="notes">
                    </mat-form-field>
                </div>
                <div fxFlexAlign="end">
                    <button mat-raised-button (click)="addNotesRow()">Add Note</button>
                </div>

                <mat-form-field class="full-width">
                    <mat-label>My Commission</mat-label>
                    <input formControlName="my_commission" type="number" matInput>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Closing Date</mat-label>
                    <input matInput formControlName="closing_date" (focus)="picker.open()" [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxFlex="25">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                        <mat-option *ngFor="let statusColumn of statusColumn" [value]="statusColumn.value">
                            {{statusColumn.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>Update</mat-label>
                    <input formControlName="update" matInput>
                </mat-form-field>
                <div>
                    <button mat-flat-button type="submit" style="color: white;" (click)="update()"
                        color="primary">Submit</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>